import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-gray-200 rounded w-32 h-8 p-3 animate-pulse"
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.logo)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString("")))
    : (_openBlock(), _createElementBlock("img", {
        key: 1,
        id: "logo",
        src: _ctx.logo ?? _ctx.image,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go.redirectToPage('home'))),
        alt: "logo"
      }, null, 8, _hoisted_2))
}